export const PREVIEW_MODE_DEFAULT_STORE_BALANCE = 5000;

export const PREVIEW_MODE_DEFAULT_CURRENCY_ID = 1;
export const PREVIEW_MODE_DEFAULT_ORDER_ID = "preview_order";
